import InvoiceIcon from '@material-ui/icons/LibraryBooks';
import InvoiceList from './InvoiceList';
import InvoiceCreate from './InvoiceCreate';

export default {
    list: InvoiceList,
    create: InvoiceCreate,
    icon: InvoiceIcon,
};
